import Vue from 'vue'
import { isWebAppQuery } from './web-auth-rules'

const scales = { small: 0.85, standard: 1, large: 1.15, extraLarge: 1.3 }
export const appFont = Vue.observable({ scale: 1 })

// A web settings choice also applies when history returns to an older web URL.
const webFontKey = 'eelink.web.fontSize'
const validFont = value => typeof value === 'string' && Object.prototype.hasOwnProperty.call(scales, value)
let webSelection = null
function savedWebFont() {
  try { const value = localStorage.getItem(webFontKey); return validFont(value) ? value : null } catch (_) { return null }
}
export function selectWebFont(value) {
  if (!validFont(value)) return
  webSelection = value
  try { localStorage.setItem(webFontKey, value) } catch (_) { /* Keep the current choice when storage is unavailable. */ }
}

// Only browser settings persist; native App URLs retain their parameter-only behavior.
export function installAppFont(router) {
  router.beforeEach((to, from, next) => {
    if (!isWebAppQuery(to.query)) webSelection = null
    else if (!webSelection) webSelection = savedWebFont() || (validFont(to.query.appFontSize) ? to.query.appFontSize : null)
    if (webSelection && isWebAppQuery(to.query) && to.query.appFontSize !== webSelection) {
      return next({ path: to.path, query: { ...to.query, appFontSize: webSelection }, hash: to.hash, replace: true })
    }
    if (Object.prototype.hasOwnProperty.call(to.query, 'appFontSize')) {
      const value = to.query.appFontSize
      appFont.scale = typeof value === 'string' && Object.prototype.hasOwnProperty.call(scales, value) ? scales[value] : 1
    }
    document.documentElement.classList.toggle('app-font-enlarged', appFont.scale > 1)
    document.documentElement.style.setProperty('--app-font-scale', appFont.scale)
    next()
  })
}
